import Navbar from './Components/Navbar/Navbar';
import React, {useContext, useEffect, useRef, useState} from 'react';
import Cookies from 'js-cookie';
import {store} from "./Store/store";

import './App.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import axios, {
    ACCESS_TOKEN_COOKIE,
    COOKIE_OPTIONS, EXPIRY_WARNING_PERIOD,
    LOGIN_CSRF_COOKIE,
    REFRESH_TOKEN_COOKIE, storeAccessToken, TOKEN_TYPE_COOKIE
} from "./Axios/axiosConfig";
import {SET_CURRENT_USER_INFO} from "./Store/ActionTypes/General/actionTypes";
import {Expiring} from "./Axios/expiring";
import SignedOutPage from "./Pages/SignedOut/SignedOutPage";
import {isWintUser} from "./Components/ReportsGeneratorComponents/Utils/utils";
import Routes from "./Routes";
import {QueryClientProvider, QueryClient} from "@tanstack/react-query";
import {ThemeProvider} from '@mui/material/styles';
import theme from './Pages/HardwareCatalog/Theme/Theme';
import { useLocation } from 'react-router-dom';

function App() {
    const {dispatch} = useContext(store);
    const faviconRef = useRef(null);
    const [initComplete, setInitComplete] = useState(false);
    const isSignedOutPage = (document.location.pathname === "/signed-out");
    const Tokens = require('csrf');
    const queryClient = new QueryClient();
    const [isCookieSaved, setIsCookieSaved] = useState(false);
    const location = useLocation();
    const isControlUnitsWithId = /^\/controlUnits\/\d+$/.test(location.pathname);

    useEffect(() => {
        if (!isSignedOutPage) {
            function login() {
                const tokens = new Tokens();
                const csrf = tokens.secretSync()
                Cookies.set(LOGIN_CSRF_COOKIE, csrf, COOKIE_OPTIONS);

                const loginUrlParams = new URLSearchParams({
                    response_type: 'code',
                    client_id: process.env.REACT_APP_OAUTH_CLIENT_ID,
                    redirect_uri: process.env.REACT_APP_OAUTH_SERVER_URL +
                        process.env.REACT_APP_OAUTH_CLIENT_REDIRECT_PATH +
                        '?clientId=' + process.env.REACT_APP_OAUTH_CLIENT_ID,
                    scope: process.env.REACT_APP_OAUTH_CLIENT_SCOPE,
                    state: csrf
                });

                const loginUrl = new URL(process.env.REACT_APP_OAUTH_LOGIN_URL);
                loginUrlParams.forEach((value, key) => loginUrl.searchParams.append(key, value));
                window.location.replace(loginUrl.toString());
            }

            const sessionAccessToken = Cookies.get(ACCESS_TOKEN_COOKIE);
            const sessionRefreshToken = Cookies.get(REFRESH_TOKEN_COOKIE);
            const sessionTokenType = Cookies.get(TOKEN_TYPE_COOKIE);
            if (sessionAccessToken && sessionRefreshToken && sessionTokenType) {
                setInitComplete(true);
                setIsCookieSaved(true);
            } else {
                const params = new URLSearchParams(window.location.search);
                const sessionId = params.get('sessionId');
                let accessToken;
                let accessTokenLifetime
                let refreshToken;
                let refreshTokenLifetime;
                let csrf;

                if (!sessionId) {
                    setInitComplete(false);
                    login();
                }

                const url = new URL(`${process.env.REACT_APP_OAUTH_SERVER_URL}${process.env.REACT_APP_OAUTH_CLIENT_REDIRECT_PATH}/sessions/${sessionId}`);
                fetch(url).then(async response => {
                    const res = await response.json();
                    accessToken = res.accessToken;
                    accessTokenLifetime = res.accessTokenLifetime;
                    refreshToken = res.refreshToken;
                    refreshTokenLifetime = res.refreshTokenLifetime;
                    csrf = res.csrf;
                    if (accessToken != null) {
                        const expectedCsrf = Cookies.get(LOGIN_CSRF_COOKIE);
                        setInitComplete(storeAccessToken(
                            Expiring.fromNow(accessToken, accessTokenLifetime - EXPIRY_WARNING_PERIOD),
                            Expiring.fromNow(refreshToken, refreshTokenLifetime - EXPIRY_WARNING_PERIOD),
                            csrf, expectedCsrf));
                    }
                    setIsCookieSaved(true);
                }).catch(err => {
                    console.error('err', err)
                }).finally(() => {
                        const location = new URL(window.location.href);
                        location.searchParams.delete('sessionId');
                        const nextURL = location.toString();
                        const nextTitle = document.title;
                        const nextState = {additionalInformation: 'removed login params'};
                        // create a new entry in the browser's history, without reloading
                        window.history.pushState(nextState, nextTitle, nextURL);

                    }
                )


            }
        }
    }, [isSignedOutPage, Tokens]);

    useEffect(() => {
        if (!isSignedOutPage && isCookieSaved) {
            axios.get(`${process.env.REACT_APP_OAUTH_SERVER_URL}/user/info`).then(response => {
                dispatch({
                    type: SET_CURRENT_USER_INFO,
                    payload: {
                        isWintUser: isWintUser(response.data.email),
                        userRole: response.data.userRole,
                        currentUserId: response.data.userId,
                        email: response.data.email
                    }
                });
            }).catch((err)=>{
                console.log('err',err)
                }
            )
        }
    }, [isSignedOutPage, dispatch, isCookieSaved])

    useEffect(() => {
        faviconRef.current = document.querySelector("link[rel~=\'icon\']");
        const environment = process.env.REACT_APP_ENV;
        console.log('environment', environment);
        if (faviconRef.current) {
            console.log('inside faviconRef.current');
            if (environment === 'preprod') {
                console.log('inside environment === \'preprod\'');
                faviconRef.current.href = '/tau_fav.ico';
                console.log('after assigning to faviconRef.current.href');
            }
        }
    }, []);

    let body;
    if (isSignedOutPage) {
        body = <SignedOutPage/>
    } else {
        body = initComplete ? <Routes/> : <p>Loading...</p>
    }

    return (
        <ThemeProvider theme={theme}>
            <QueryClientProvider client={queryClient}>
                <div className="App"
                     style={{ overflow: isControlUnitsWithId ? 'hidden' : 'auto' }}>
                    <Navbar isSignedOutPage={isSignedOutPage}/>
                    {body}
                </div>
            </QueryClientProvider>
        </ThemeProvider>
    );
}

export default App;
